import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { ChildSavingStepParams } from './types'
import { amountOfMoneySchema } from './types'

export const amountOfMoney = (params: ChildSavingStepParams) => {
  const schema = amountOfMoneySchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_childSaving:steps.amount_of_money.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_child_saving_de.shape.configuration_parameters.shape.amount_of_money.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_childSaving:steps.amount_of_money.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('amount_of_money'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'sustainability',
    subFlow: SubFlow.ChildSaving,
  } as const satisfies AnyStepConfiguration
}
